import React from "react"
import { FormContainer, Worksheet } from "uikit"
import { Footer } from "./Footer"
import { useStore } from "store"

const EmployerForm = ({
  data: {
    fields: { name, description, household_id },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Done",
  submitHeader = "",
  onCancel,
  onDelete,
  baseUrl,
  household,
  hasIncome
}) => {
  const confirmText = hasIncome ? (
    <span>
      Deleting this Employer will also delete its associated incomes/benefits.
      <strong> You cannot undo this action.</strong>
    </span>
  ) : (
    <span>
      If you proceed, you will permanently remove this Employer.
      <strong>YOU CANNOT UNDO THIS ACTION.</strong>
    </span>
  )
  return (
    <Worksheet error={error}>
      <Worksheet.Body>
        <Worksheet.Row label="Employer Name" paddedField>
          <Worksheet.Field error={name.error}>
            <input {...name} />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row label="Description" paddedField>
          <Worksheet.Field error={description.error}>
            <input {...description} />
          </Worksheet.Field>
        </Worksheet.Row>
        <Footer
          baseUrl={baseUrl}
          submitLabel="Done"
          isNew={false}
          deleteText={confirmText}
          onSubmit={onSubmit}
          onCancel={onCancel}
          isPending={isPending}
          onDelete={onDelete}
          isModified={isModified}
          deleteLabel="Delete"
          entityName="employer"
          error={error}
        />
      </Worksheet.Body>
    </Worksheet>
  )
}

const EmployerWorksheetFormContainer = FormContainer(
  {
    name: {
      type: "string"
    },
    description: {
      type: "string",
      required: false
    }
  },
  (fields, ...form) => {}
)(EmployerForm)

const EmployerWorksheet = ({ household, employerId, ...formProps }) => {
  const [employer] = useStore("employers", employerId)
  const [incomes] = useStore("householdIncomes", household.id)
  const [
    benefits,
    { updateEmployer, deleteEmployer, deleteBenefit, deleteIncome }
  ] = useStore("householdBenefits", household.id)

  const addedIncomes = Object.values(incomes).filter(
    ({ employer_id }) => employer_id === employer.id
  )
  const addedBenefits = Object.values(benefits).filter(({ income_id }) =>
    addedIncomes.map(({ id }) => id).includes(income_id)
  )
  const submit = async values =>
    await updateEmployer({ id: employer.id, ...values })
  const onDelete = async () => {
    await Promise.all(
      addedBenefits.map(({ id }) =>
        deleteBenefit({
          id,
          household_id: household.id
        })
      )
    )
    await Promise.all(
      addedIncomes.map(({ id }) =>
        deleteIncome({
          id,
          household_id: household.id
        })
      )
    )
    await deleteEmployer({
      id: employer.id,
      household_id: household.id
    })
  }
  return (
    <EmployerWorksheetFormContainer
      {...{
        values: employer,
        submit,
        onDelete,
        hasIncome: addedIncomes.length >= 1,
        ...formProps
      }}
    />
  )
}

export default EmployerWorksheet
